// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"244":"be4d7a48","251":"a4b6475f","288":"8f7bc5e7","301":"00a3a099","431":"2b78bd8a","556":"993d36a9","613":"f0f3a418","861":"9468bd4e","931":"8b468608","953":"91af0fbf","976":"a18a6404"}[chunkId] + ".bc-checkout-shop-app.js";
};